import React from 'react'
import clsx from 'classnames'
import { Arrow } from 'components/Utility/Arrow/Arrow'
import styles from './ServicesCategory.module.scss'

type ServicesCategoryProps = {
  name: string,
  image: string,
  /** Shown when expanded: all services of the category */
  expanded: React.ReactNode[],
  /** Shown when collapsed: only the selected services */
  collapsed: React.ReactNode[],
  isExpanded: boolean,
  onExpand: () => void,
  onCollapse: () => void,
}

export const ServicesCategory: React.FC<ServicesCategoryProps> = (props) => {
  const { name, image, expanded, collapsed, isExpanded, onExpand, onCollapse } = props
  const visible = isExpanded ? expanded : collapsed
  const hasActiveChildren = React.Children.count(visible) > 0

  return (
    <div className={clsx({
      [styles.container]: true,
      [styles.expanded]: isExpanded,
      [styles.withChildren]: visible.length > 0,
    })}>
      <div className={styles.header} onClick={isExpanded ? onCollapse : onExpand}>
        <i className={styles.image} style={{ backgroundImage: `url(${image})` }} />
        <div className={styles.headerText}>
          <span className={styles.name}>{name}</span>
          <Arrow className={styles.arrow} direction={isExpanded ? 'down' : 'right'} />
        </div>
      </div>
      {hasActiveChildren && <div className={styles.children}>
        {visible}
      </div>}
    </div>
  )
}
